import { render, staticRenderFns } from "./GraveTasks.vue?vue&type=template&id=02b5b028"
import script from "./GraveTasks.vue?vue&type=script&lang=js"
export * from "./GraveTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports